<template>
  <div class="home-nearby">
    <h3>
      <span class="home-nearby-text">身边活动</span>
      <a
        class="show-more"
        href="//huodong.cekid.com/hd/actListByAge?agetype=1&isMiniProgram=false"
        @click="trackClick(200027, '身边活动查看全部', '', 121011908)"
      >
        <span class="home-nearby-more" v-if="list && list.length > 3"
          >更多</span
        >
      </a>
    </h3>
    <div class="activities" v-if="list && list.length">
      <ul>
        <li
          v-for="(item, index) in list"
          :key="index"
          @click="jump(item.activityId, index)"
        >
          <!-- <swipe :auto="5000">
                <swipe-item v-for="(item,index) in list" :key="index"> -->
          <div class="each-ui">
            <div class="img-layout">
              <img
                v-lazy="
                  $$viewImage(item.coverPhotoUrl, 400, 300) ||
                  'https://hzwimspic-1251601690.picsh.myqcloud.com/22fec120-56e2-11ea-a92c-d30c8fbccdfb_size_375x225?imageView2/2/w/220/h/132/q/90'
                "
                class="left"
              />
              <p>
                <span>{{ formatTime(item.activityTimeStart) }}&nbsp;开始</span>
              </p>
            </div>

            <div class="bottom">
              <p>{{ item.activityTheme }}</p>
              <div class="store">
                <!-- <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAAGWB6gOAAAAAXNSR0IArs4c6QAABQxJREFUWAnNl1toXFUUhntOJuNM2kiikaqNF8RbrS2mUqXYglVpvTzUPjSKTZHc9UXw2krBFBRsTWtffEkmISSQEYOofWhApOZBiQ9qioqWpIiCNFitOEiwkkkyfv+ZWYcz0ySTmdHQDeusva577bUvax9nBa2rqyslrOY4zvCK7u7uU2ky/e3v778ySC/clyvXxBAHre9AnIdYxM/w8PBlpi7sTk5ObslizM7O7g0yFPmzWYwcgom8EIJ378jISGxiYiLpuu4dqVRqlGk+Mzc39zz4E+ibPDu01+U48El/Yni42rjBCRpPE90I8bUxcnF7e7uTlfJcBdH+cPMJgzwv2czAlYVZBrGvjEJFRnB9Bt8u7M/aPIg5X0P+ir+28ymIR0Kvu0hpPs8XKQU9slwhJjXu9PX1Raanpy8gnML1L0GlpfRxsha7c6FkMtktA7JfuRTDXB2msA1nnyrsJ4CfTYH0vR+cX29v7+YgPTQ0tCpIE8CIbB19ECRB2qLKnBbwDKPcKloN3nHonWnK+8b5PmU0mzH7QJigGGwRpcrKyh5qaWk5WagTTZOI31l0aeWUnO0J5mShgfI6Ije3LGQc5NvU9sN8MygopK+D6zki/BOM/GghxhndP8DbcTTm4ORXnKwmYaeLcFSLbWU4HI7qnMjJy21tbUeKcORdNRyxRi/ZOPqqGCdmg32d5ygajY4Zs0i80XPU0NDwlznQnonFYncHafL4ktH0LwAfGE005+iv8xwh6JUAJ16euP4/Ft3T03OnMHnsFB4cHKymHwF2AQ4HOAxeDfTpcm9BJyZFNUY4jGBfmvLo09BrA3QCuspocJLlD/s0UWXVHKK5wRfSgb6CCMqMNzAwsDK3UJqsNMzUDijBxXjh0rvNbF1y4lfIQp2Rq1qz8VbNiFJwXkcKnYXYk2+QvI7kgCnkvZOW5ChfNJK7jDaujiqmcCEt+JyyG7Ko5c8M+io7+5A5egzmR0DBURUyg0V0Z5A9TkAnHI7QfUz1cymzN7+sqqp6oL6+fmoR4/9MpOqfSCROskz3yCmldYtLMH5FJ6BjyxWMAtBYjPm2+mrEskMndkOaZEe5bqkXt7laMiYr35kysdTpmp2EcQ3wN2u40oSGdd8Q+QHobxeqexzofaT9WopkR2NjY8JsDSN/EvnD5eXlbzU1Nf1gfGH4KtDTdLV/z+q8/glo/4QIzntIi1bT0SOYUYz2Ap3I9c7Iajh7DdkhmM9RbN/LEkJQ1bYif5fu0zMzM/onyboj4vG4aojxfnOUART1mxYF1H4EtHTrAe9lD/Ybgf8DMQLozrgfnPWzBa32BXp6lmylX+NxAh9k3yNTpjYBN2ZEU2yZDW5zc/M4S1URCoU2oTiKUL8Zu+nrOhxDaRtyp7q6ugLeMRxNAY8AO6BV4zv1npEOui3wfoK3Gfku+lHgw0gkUpuRb0f2DTJV2t3AGuSfMfZdyCtbW1tle2k1uxhriPQNIj9DpEeXM0T2WDOPnpvJ8mEdCG8zEUwHwbQTyBEuygeXKyCNRTA9jLeff7PXNa7t7uWKIe84JdcuMuuQdu9/jU0ZJ9ulFNjSiyn3UAfTFugvTCfzoPrFtktuySwgP81sspKXcanZCY7F0s/Jzjv2mdtaRa7cYzrO7+Dz6udrOLocnTUZvbPsIf+HKI9tDbZXZXSSXI7rdUl7AZkhm3MnSi8CdfBWGf9/wnp6nAKOchiO2xj/AklNSvX9kU0DAAAAAElFTkSuQmCC"/> -->
                <span>{{ item.storeName }}</span>
              </div>
              <!-- <div class="bottom">
                                <div class="time">
                                    <span>活动时间</span>
                                    <span>{{formatTime(item.activityTimeStart)}}</span>
                                </div>
                                <button class="operate" @click="jump(item.activityId)">感兴趣</button>
                            </div> -->
            </div>
          </div>
        </li>
        <!-- </swipe-item>
            </swipe> -->
      </ul>
    </div>
  </div>
</template>

<script>
import { Swipe, SwipeItem } from 'mint-ui'
import utils from '@/plugins/utils'

export default {
  PAGE_ID: '288987',
  props: {
    list: {
      type: Array,
      default() {
        return []
      }
    },
    citycode: Number | String,
    cityname: String,
    lat: String,
    lng: String
  },
  methods: {
    formatTime(time) {
      return utils.dateFormat(time, 'YY.MM.DD hh:mm')
    },
    jump(id, index) {
      this.trackClick(200028, { activeid: id }, '', 121011908, `${index + 1}`)
      location.href = `//huodong.cekid.com/hd/detail/${id}?citycode=${this.citycode}&cityname=${this.cityname}&&lat=${this.lat}&lng=${this.lng}&isMiniProgram=false&refresh=no`
    }
  },
  components: {
    Swipe,
    SwipeItem
  }
}
</script>

<style lang="scss">
@import '../../assets/css/mixin';
.home-nearby {
  padding: 0 rem(30px);
  padding-bottom: rem(30px);
  .show-more {
    display: flex;
    align-items: center;
    //  .icon{
    //     display: inline-block;
    //     height: rem(18px);
    //     width: rem(10px);
    //     margin: 0 0 rem(2px) rem(10px);
    //     background: url('//cmspic-10004025.image.myqcloud.com/a887b720-0205-11ea-98a0-c91677e5da3e_size_9x18') no-repeat center center;
    //     background-size: rem(8px) auto;
    // }
  }
  h3 {
    padding: rem(30px) 0;
    display: flex;
    align-items: center;
    line-height: 1;
    // background: url('https://hzwimspic-1251601690.picsh.myqcloud.com/d6562450-4edd-11ea-a8d7-a9d7fb9b08b4_size_1053x92') no-repeat;
    // background-size: 100% 33px;
    .home-nearby-text {
      flex: 1;
      font-size: rem(36px);
      font-weight: 600;
      color: #000;
    }
    a {
    }
    .home-nearby-more {
      font-size: rem(24px);
      color: #999;
    }
    // .iconfont{
    //     display: inline-block;
    //     color:#666;
    //     font-size: rem(24px);
    //     transform: rotate(-90deg);
    // }
  }

  .activities {
    position: relative;
    overflow: hidden;
    border-radius: rem(16px);
    border-bottom-left-radius: 0;
    ul {
      overflow-x: auto;
      display: -webkit-box;
      &::-webkit-scrollbar {
        display: none;
      }
      li {
        &:first-child .each-ui {
          margin-left: 0;
        }
        &:last-child .each-ui {
          margin-right: 0;
        }
      }
    }
    .each-ui {
      width: rem(320px);
      margin: 0 rem(9px);
      .img-layout {
        width: 100%;
        height: rem(192px);
        border-radius: rem(12px);
        overflow: hidden;
        position: relative;
        &::before {
          content: '';
          position: absolute;
          display: block;
          bottom: 0;
          left: 0;
          right: 0;
          z-index: 1;
          height: rem(50px);
          opacity: 0.6;
          background-image: linear-gradient(
            180deg,
            rgba(0, 0, 0, 0) 0%,
            #000000 100%
          );
        }
        img {
          width: 100%;
          height: 100%;
        }
        p {
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          z-index: 2;
          height: rem(50px);

          padding: 0 rem(14px);

          font-size: rem(20px);
          text-align: right;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;

          span {
            display: inline-block;
            vertical-align: bottom;
            line-height: rem(24px);
            margin-top: rem(18px);

            color: #fff;
          }
        }
      }
      .bottom {
        width: 90%;
        & > p {
          margin-top: rem(24px);
          margin-bottom: rem(12px);
          line-height: rem(34px);
          font-size: rem(30px);
          color: #121212;
          font-weight: 500;
          @include ellicpsis;
        }
        .store {
          font-size: rem(26px);
          color: #999999;
          line-height: 1.2;
          @include ellicpsis;
        }
      }
    }
  }
}
</style>
